import { onlyLine, moreLine, stackLine, otherLine } from './components';
export default {
  name: 'lineChart',
  components: {
    onlyLine,
    moreLine,
    stackLine,
    otherLine
  },
  data() {
    return {};
  }
};